/* Copyright (c) 2023 GRIP.S Medien GmbH & Co.KG */

import SwaggerApi from './SwaggerApi';

class Api extends SwaggerApi {
  constructor(apiOptions = {}) {
    super({
      api: '/api/v1',
      ...apiOptions,
    });
    this.isClosed = true;
    this.isAdmin = false;

    // this.init();
  }

  setClosed = (isClosed) => (this.isClosed = isClosed);

  setAdmin = (isAdmin) => (this.isAdmin = isAdmin);
}

export default new Api();
